import Swiper, { Navigation, Pagination, Lazy } from "swiper"

export default class NewsSlider {

  constructor (el) {
    this.el = el
    this.slider = null
    this.container = this.el.closest('.inner__block')
    this.prev = this.container.querySelector('.swiper-controls__btn--prev')
    this.next = this.container.querySelector('.swiper-controls__btn--next')
    this.prevMobile = this.container.querySelector('.swiper-navigation__btn--prev')
    this.nextMobile = this.container.querySelector('.swiper-navigation__btn--next')
    this.pagination = this.container.querySelector('.swiper-navigation__pagination')
    this.isMobile = false
  }

  init () {
    this.initSlider()
    this.initEvents()
  }

  initEvents () {
    window.addEventListener('resize', () => this.updateSlider())
  }

  updateSlider () {
    if (window.innerWidth < 768) {
      if (this.isMobile) return;
      this.isMobile = true
      this.destroySlider()
      this.initSlider()
    } else {
      if (!this.isMobile) return;
      this.isMobile = false
      this.destroySlider()
      this.initSlider()
    }
  }

  initSlider () {
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, Pagination, Lazy ],
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
      },
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: window.innerWidth < 768 ? this.prevMobile : this.prev,
        nextEl: window.innerWidth < 768 ? this.nextMobile : this.next
      },
      pagination: {
        el: this.pagination
      },
      observer: true,
      breakpoints: {
        1601: {
          spaceBetween: 50,
          slidesPerView: 2
        },
        1025: {
          spaceBetween: 32,
          slidesPerView: 2
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 2
        }
      }
    })
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
  }

}
